import { daysOfWeek } from 'common/constans/common.constants';

export const daysOfWeekOptions = [
  {
    title: 'All days',
    value: 'SelectAll',
    children: [...daysOfWeek.map((item) => ({ title: item, value: item }))],
  },
];
